// extracted by mini-css-extract-plugin
export default {"header":"ShiftModalHeader--header--e10246","image":"ShiftModalHeader--image--7df2ff","title":"ShiftModalHeader--title--f50c56","date":"ShiftModalHeader--date--fe294e"};